import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
export const ELETRONIC_PRESCRIPTION_FIELD_JUSTIFICATION_VALIDATOR = 'eletronic-prescription-field-justification-validator';
async function eletronicPrescriptionJustificationValidator(value) {
    if (!value) {
        return [
            {
                message: MessageService.translate('message.eletronic-prescription.field-justification-requerid'),
                name: ELETRONIC_PRESCRIPTION_FIELD_JUSTIFICATION_VALIDATOR,
                valid: false,
            },
        ];
    }
    return [
        {
            message: '',
            name: ELETRONIC_PRESCRIPTION_FIELD_JUSTIFICATION_VALIDATOR,
            valid: true,
        },
    ];
}
export default eletronicPrescriptionJustificationValidator;
//# sourceMappingURL=eletronic-prescription-field-justification-validator.js.map